import type { DominanceItem } from "./types";
import { I18nUtil } from "@utils/i18n";
import React from "react";
import { SegmentedBar } from "@/src/components/SegmentedBar";
import Translations from "@translate/components/Home/MarketIndicators/BitcoinDominance/BitcoinDominanceH5";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

interface BitcoinDominanceH5Props {
  /** 标题 */
  title?: string;
  /** 数据列表 */
  data?: DominanceItem[];
  /** 自定义类名 */
  className?: string;
  /** 标题自定义类名 */
  titleClassName?: string;
}

export const BitcoinDominanceH5: React.FC<BitcoinDominanceH5Props> = ({
  title = I18n.t("Bitcoin Dominance"),
  data = [],
  className,
  titleClassName,
}) => {
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      {/* 标题 */}
      <h3
        aria-label="Bitcoin Dominance H5 h3"
        data-openreplay-label="Bitcoin Dominance H5 h3 Semantic"
        id="sem-bitcoin-dominance-h5-h3"
        className={cn("body_medium_s text-content_tertiary", titleClassName)}
      >
        {title}
      </h3>

      {/* 数据列表 */}
      <div className="flex flex-col gap-1">
        {data.map((item) => (
          <div key={item.name} className="flex items-center justify-between">
            {/* 左侧：币种名称 */}
            <div className="flex items-center gap-1">
              {/* 颜色指示器 */}
              <div
                className="w-[6px] h-[6px] rounded-full"
                style={{ backgroundColor: item.color }}
              />
              <span className="body_medium_s text-content_primary">
                {item.symbol}
              </span>
            </div>

            {/* 右侧：百分比和变化 */}
            <div className="flex items-center gap-1">
              <span className="body_bold_s text-content_primary">
                {item.percentage}%
              </span>
              <div
                className={cn(
                  "flex items-center gap-[2px] body_m",
                  item.change >= 0
                    ? "text-content_accent1_primary"
                    : "text-content_accent2_primary",
                )}
              >
                <span className="body_medium_xs">
                  {item.change >= 0 ? "+" : "-"}
                  {Math.abs(item.change)}%
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* 可视化条形图 */}
      <SegmentedBar
        data={data.map((item) => ({
          id: item.name,
          value: item.percentage,
          color: item.color,
        }))}
        className="mt-1"
      />
    </div>
  );
};
